import React from 'react';
import TabNavigation from 'src/components/sticky-tab-nav';
import { Tab } from 'src/components/sticky-tab-nav/types';
import { IProductNavigationProps } from './types';
import { getLinks } from './utils';

const ProductNavigation: React.FC<IProductNavigationProps> = props => {
  const { product, selectedCondition } = props;

  if (!product) {
    return null;
  }

  const navigationTabs: Tab[] = getLinks(product, selectedCondition);
  const defaultActiveTabId = navigationTabs[0].id;

  return (
    <TabNavigation
      defaultActiveTabId={defaultActiveTabId}
      tabs={navigationTabs}
    />
  );
};

export default ProductNavigation;
